import { createSlice } from 'redux-starter-kit'

import {
  createGroup,
  fetchGroups,
  fetchRecruiter,
  extract_token,
  register_by_token,
  add_recruiter,
  edit_recruiter,
  confirm_status,
  fetch_group_program,
  delete_recruiter,
  delete_group,
  edit_group,
  fetchPassPolicy,
} from '../apis/group'

let initialState = {
  groups: [
    {
      groupName: '',
      gid: '',
      billingAdmin: {
        email: '',
        status: ''
      },
      admin: [],
      recruiter: []
    }
  ],
  recruiterList: [],
  programList: []
}

const groupSlice = createSlice({
  slice: 'group',
  initialState: initialState,
  reducers: {
    onGettingGroupInfo (state, action) {
      state.groups = action.payload
    },
    onGettingRecruiterInfo (state, action) {
      state.recruiterList = action.payload
    },
    onGettingGroupProgram (state, action) {
      state.programList = action.payload
    }
  }
})

export const fetchRecruiterGroups = token => async dispatch => {
  try {
    const res = await fetchGroups(token)
    if (res.obj.error_code == 0) dispatch(onGettingGroupInfo(res.obj.message))
  } catch (err) {
    console.log(err)
  }
}

export const createGroups = req => async dispatch => {
  try {
    const res = await createGroup(...req)
    return res
    console.log(res, 'result')
  } catch (err) {
    console.log(err, 'result')
  }
  return 'ans'
}
export const getGroupsRecruiter = req => async dispatch => {
  try {
    const res = await fetchRecruiter(...req)
    console.log(res, 'result')
    if (res.obj.error_code == 0)
      dispatch(onGettingRecruiterInfo(res.obj.message))
    return res
    console.log(res, 'result')
  } catch (err) {
    console.log(err, 'result')
  }
  return 'ans'
}

export const getEmailFromToken = token => async dispatch => {
  
  // Default response
  let response = {
    email: null,
    error_code: 9,
    message: "Unknown error"
  }

  try {
    const res = await extract_token(token)
    // Valid token for registration
    if (res.obj?.error_code == 0) {
      response.email = res.obj.msg
      response.error_code = 0
    }
    else if (res.obj?.error_code == 1) {
      response.error_code = 1
      response.message = "Token expired"
    }
    else if (res.obj?.error_code == 2) {
      response.error_code = 2
      response.message = "Token invalid"
    }
    else if (res.obj?.error_code === 3) {
      response.error_code = 3
      response.message = "Token invalid"
    }
    else if (res.obj?.error_code == 4) {
      response.error_code = 4
      response.message = "The link has been cancelled by the host user"
    } else if (res.obj?.error_code == 10) {
      response.error_code = 10
      response.message = "The recruiter has already been registered"
    }
      console.log(res, 'result')
  } catch (err) {
    console.log(err, 'result')
  }
  return response

}


export const registerRecruiter = args => async dispatch => {
  try {
    const res = await register_by_token(...args)

    if (res.obj.error_code === 0){
      return {status: 'success', msg: res.obj.message}
    } else{
      return {status: 'error', msg: res.obj.message}
    }
  } catch (err) {
    console.log(err, 'result')
    return {status: 'error', msg: 'unknown_error'}
  }
}

export const invite_recruiter = args => async dispatch => {
  try {
    const res = await add_recruiter(...args)

    if (res.obj.error_code == 0) return res.obj.msg
    else return res.obj.error_code
    console.log(res, 'result')
  } catch (err) {
    console.log(err, 'result')
  }
  return 'ans'
}

export const edit_recruiter_role = args => async dispatch => {
  try {
    const res = await edit_recruiter(...args)

    if (res.obj.error_code == 0) return res.obj.msg
    else return res.obj.error_code
    console.log(res, 'result')
  } catch (err) {
    console.log(err, 'result')
  }
  return 'ans'
}

export const confirm_adminBilling_role = args => async dispatch => {
  try {
    const res = await confirm_status(...args)
    

    if (res.obj.error_code == 0) return res.obj.msg
    else return res.obj.error_code
    console.log(res, 'result')
  } catch (err) {
    console.log(err, 'result')
  }
  return 'ans'
}

export const getGroupProgrammeStatistics = token => async dispatch => {
  try {
    const statResponses = await fetch_group_program(token)
    const payload = []
    if (statResponses.ok && statResponses.obj && statResponses.obj.result) {
      statResponses.obj.result.forEach(statResponse => {
        payload.push({
          jobId: statResponse.job_id,
          numOfCandidates: statResponse.total_candidates,
          deadline: statResponse.interview_deadline.split(' ')[0] || '-',
          completion: statResponse.completed_candidates,
          reviewed: statResponse.ai_reviewed_candidates,
          questionNum: statResponse.num_of_question,
          completionRate:
            statResponse.total_candidates && statResponse.total_candidates > 0
              ? Math.round(
                  (statResponse.ai_reviewed_candidates /
                    statResponse.total_candidates) *
                    100
                )
              : 0,
          gid: statResponse.gid,
          groupName: statResponse.groupName,
          test: statResponse.test,
          program_name: statResponse.program_name,
          job_name: statResponse.job_name,
          created_at: statResponse.created_at
        })
      })
    }
    dispatch(onGettingGroupProgram(payload))
  } catch (e) {
    console.log(e)
  }
}

export const confirm_delete_recruiter = args => async dispatch => {
  try {
    const res = await delete_recruiter(...args)
    

    if (res.obj.error_code == 0) return res.obj.msg
    else return res.obj.error_code
    console.log(res, 'result')
  } catch (err) {
    console.log(err, 'result')
  }
  return 'ans'
}

export const confirm_delete_group = args => async dispatch => {
  try {
    const res = await delete_group(...args)

    if (res.obj.error_code == 0) return res.obj.msg
    else return res.obj.error_code
    console.log(res, 'result')
  } catch (err) {
    console.log(err, 'result')
  }
  return 'ans'
}

export const confirm_edit_group = args => async dispatch => {
  try {
    const res = await edit_group(...args)

    if (res.obj.error_code == 0) return res.obj.msg
    else return res.obj.error_code
    console.log(res, 'result')
  } catch (err) {
    console.log(err, 'result')
  }
  return 'ans'
}

export const getPassPolicyFromToken = token => async dispatch => {
  // default response
  let response = {
    passPolicy: null,
    errorCode: 9,
    msg: "Unknown error"
  }

  let res = await fetchPassPolicy(token)
  if (!res.obj)
    return response

  const result = res.obj
  response.errorCode = result.error_code
  response.msg = result.msg

  if (result.error_code === 0) {
    const passPolicy = result.pass_policy
    response.passLen = passPolicy.passlen ?? 12
    response.passStrength = {
      "upcase": passPolicy.strength?.upcase ?? true,
      "lowcase": passPolicy.strength?.lowcase ?? true,
      "number": passPolicy.strength?.number ?? true,
      "symbol": passPolicy.strength?.symbol ?? true
    }
  } 

  return response
}


export const {
  onGettingGroupInfo,
  onGettingRecruiterInfo,
  onGettingGroupProgram
} = groupSlice.actions

export default groupSlice.reducer
